<template><section>

<h2 id="cell-zu-jian"><a class="header-anchor" href="#cell-zu-jian" aria-hidden="true">¶</a> Cell 组件</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa" aria-hidden="true">¶</a> 基础用法</h3>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-cell-group</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"单元格1"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"单元格1内容"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"单元格2"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"单元格2内容"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell-group</span>&gt;</span>
</code></pre>
<h3 id="biao-ti-dai-miao-shu-xin-xi"><a class="header-anchor" href="#biao-ti-dai-miao-shu-xin-xi" aria-hidden="true">¶</a> 标题带描述信息</h3>
<p>传入<code>label</code>属性，属性值为描述信息的值。</p>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-cell-group</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"单元格1"</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"描述信息"</span> <span class="hljs-attr">is-link</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"javascript:void(0)"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"handleClick"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"单元格2"</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"描述信息"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell-group</span>&gt;</span>
</code></pre>
<h3 id="dai-tu-biao"><a class="header-anchor" href="#dai-tu-biao" aria-hidden="true">¶</a> 带图标</h3>
<p>传入<code>icon</code>属性。</p>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-cell-group</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"起码运动馆"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"home"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"线下门店"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"location"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell-group</span>&gt;</span>
</code></pre>
<h3 id="ke-dian-ji-de-lian-jie"><a class="header-anchor" href="#ke-dian-ji-de-lian-jie" aria-hidden="true">¶</a> 可点击的链接</h3>
<p>传入<code>url</code>属性，传入<code>isLink</code>属性则会在右侧显示箭头。</p>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-cell-group</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"起码运动馆"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"进入店铺"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"home"</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://youzan.com"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"线下门店"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"location"</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://youzan.com"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell-group</span>&gt;</span>
</code></pre>
<h3 id="gao-ji-yong-fa"><a class="header-anchor" href="#gao-ji-yong-fa" aria-hidden="true">¶</a> 高级用法</h3>
<p>如以上用法不能满足你的需求，可以使用对应的<code>slot</code>来自定义显示的内容。包含三个<code>slot</code>，默认<code>slot</code>，<code>icon</code>和<code>title</code>的<code>slot</code>。</p>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-cell-group</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"进入店铺"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"home"</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://youzan.com"</span> <span class="hljs-attr">is-link</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"title"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"zan-cell-text"</span>&gt;</span>起码运动馆<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">img</span> <span class="hljs-attr">src</span>=<span class="hljs-string">"//su.yzcdn.cn/v2/image/account/icon_guan_160421.png"</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"official-img"</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">zan-cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"线下门店"</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"location"</span> <span class="hljs-attr">url</span>=<span class="hljs-string">"http://youzan.com"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">zan-cell-group</span>&gt;</span>
</code></pre>
<h3 id="api"><a class="header-anchor" href="#api" aria-hidden="true">¶</a> API</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>icon</td>
<td>左侧图标</td>
<td>string</td>
<td>''</td>
<td>''</td>
</tr>
<tr>
<td>title</td>
<td>左侧标题</td>
<td>string</td>
<td>''</td>
<td>''</td>
</tr>
<tr>
<td>value</td>
<td>右侧内容</td>
<td>string</td>
<td>''</td>
<td>''</td>
</tr>
<tr>
<td>isLink</td>
<td>是否为链接，链接会在右侧出现箭头</td>
<td>boolean</td>
<td>''</td>
<td>''</td>
</tr>
<tr>
<td>url</td>
<td>跳转链接</td>
<td>string</td>
<td>''</td>
<td>''</td>
</tr>
<tr>
<td>label</td>
<td>描述信息，显示在标题下方</td>
<td>string</td>
<td>''</td>
<td>''</td>
</tr>
</tbody>
</table>
<h3 id="slot"><a class="header-anchor" href="#slot" aria-hidden="true">¶</a> Slot</h3>
<table class="table"><thead>
<tr>
<th>name</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>-</td>
<td>自定义显示内容</td>
</tr>
<tr>
<td>icon</td>
<td>自定义icon</td>
</tr>
<tr>
<td>title</td>
<td>自定义title</td>
</tr>
</tbody>
</table>
</section></template>
<style>
.official-img {
  width: 31px;
  vertical-align: middle;
  border: 0;
}
</style>
<script>
export default {
  methods: {
    handleClick() {
      console.log('cell click');
    }
  }
};
</script>


// WEBPACK FOOTER //
// cell-3.vue?13acddea